import React from 'react';
import PropTypes from 'prop-types';

export default class FieldError extends React.Component {
  render() {
    if (this.props.errorMessage) {
      return (
        <span style={{ display: "inline" }} data-mount="errors" className="sb-field-invalid-feedback">
          {this.props.errorMessage}
        </span>
      );
    } else {
      // Null must be returned to prevent invariant violation
      return null;
    }
  }
}

FieldError.propTypes = {
  errorMessage: PropTypes.string
};
